import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { useLanguage } from './LanguageContext';
import { FileText, PlayCircle, Share2, BarChart3, RefreshCw, Wand2 } from 'lucide-react';
interface SlideWhatSnakkerDoesProps {
  onContinue: () => void;
}
export function SlideWhatSnakkerDoes({
  onContinue
}: SlideWhatSnakkerDoesProps) {
  const {
    t
  } = useLanguage();
  const [stage, setStage] = useState(0);
  const steps = [{
    id: 'ingest',
    icon: <FileText className="w-6 h-6 text-teal-400" data-id="element-946" />,
    title: t('Ingest', 'Indsaml'),
    desc: t('Takes existing approved content', 'Tager eksisterende godkendt indhold')
  }, {
    id: 'transform',
    icon: <Wand2 className="w-6 h-6 text-purple-400" data-id="element-947" />,
    title: t('Transform', 'Transformer'),
    desc: t('Turns them into short interactive Snaks', 'Omdanner dem til korte interaktive Snaks')
  }, {
    id: 'publish',
    icon: <Share2 className="w-6 h-6 text-sky-400" data-id="element-948" />,
    title: t('Publish', 'Udgiv'),
    desc: t('Distributes across all channels', 'Distribuerer på tværs af alle kanaler')
  }, {
    id: 'learn',
    icon: <BarChart3 className="w-6 h-6 text-rose-400" data-id="element-949" />,
    title: t('Learn', 'Lær'),
    desc: t('Captures behavioral data', 'Indsamler adfærdsdata')
  }, {
    id: 'improve',
    icon: <RefreshCw className="w-6 h-6 text-amber-400" data-id="element-950" />,
    title: t('Improve', 'Forbedr'),
    desc: t('Optimizes the next campaign', 'Optimerer den næste kampagne')
  }];
  useEffect(() => {
    const t1 = setTimeout(() => setStage(1), 400);
    const t2 = setTimeout(() => setStage(2), 1000);
    const timers = steps.map((_, idx) => setTimeout(() => setStage(3 + idx), 1500 + idx * 350));
    const finalTimer = setTimeout(() => setStage(3 + steps.length), 1500 + steps.length * 350 + 300);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
      timers.forEach(clearTimeout);
      clearTimeout(finalTimer);
    };
  }, []);
  return <div className="h-full w-full flex flex-col px-8 py-10 md:px-20 md:py-14 max-w-6xl mx-auto" data-id="element-951">
      {/* Heading */}
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="text-center space-y-4" data-id="element-952">
        <h2 className="text-4xl md:text-5xl font-serif text-white" data-id="element-953">
          {t('What Snakker Does', 'Hvad Snakker gør')}
        </h2>
        <p className="text-xl text-white/60" data-id="element-954">
          {t('The operating layer between strategy and execution.', 'Driftslaget mellem strategi og eksekvering.')}
        </p>
      </motion.div>

      {/* Steps */}
      <div className="flex-1 flex flex-col justify-center mt-10 space-y-4" data-id="element-955">
        {steps.map((step, idx) => <motion.div key={idx} initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: stage >= 3 + idx ? 1 : 0,
        x: stage >= 3 + idx ? 0 : -20
      }} transition={{
        duration: 0.5
      }} className="flex items-center gap-5" data-id="element-956">
            <div className="w-12 h-12 rounded-xl bg-navy-800/60 border border-navy-600 flex items-center justify-center text-blue-400 flex-shrink-0" data-id="element-957">
              {step.icon}
            </div>
            <span className="text-lg md:text-xl text-white/85 leading-snug" data-id="element-958">
              {step.title}
            </span>
          </motion.div>)}
      </div>

      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: stage >= 6 ? 1 : 0
    }} className="mt-16 flex justify-center" data-id="element-959">
        <Button onClick={onContinue} data-id="element-960">
          {t('Customer Journey', 'Kunderejse')}
        </Button>
      </motion.div>
    </div>;
}